import { Masthead } from "@/components/Masthead";
import { Footer } from "@/components/Footer";

export function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col vault-bg">
      <Masthead />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
